<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="row">
    <div class="col-md-12">
      <div *ngIf="varConfig.showIDs" style="background-color: yellow;">
        #{{fc.ID.value}}
      </div>
      <div class="form-group row">
        <div class="col-md-8">
          <yt-dropdown-picklist
            [ModelName]="'zaposleni'"
            [GetName]="'get'"
            [ModelProperty]="'Prezime,Ime,Jmbg'"
            [OrderBy]="'Naziv'"
            [AllowAddNew]="false"
            formControlName="OsobaID"
            [Label]="'PRAVONAGO.OSOBA.SINGULAR'"
          >
          </yt-dropdown-picklist>
          <div class="form-error" *ngIf="submitted && fc.OsobaID.invalid">
            <span *ngFor="let validation of errorMessages.OsobaID">
              <span class="error-message" *ngIf="fc.OsobaID.hasError(validation.type)">
                <span translate="{{validation.message}}"></span>
              </span>
            </span>
          </div>
        </div>
        <div class="col-md-4">
          <yt-input [Type]="'NUMERIC'" name="numberGodina" formControlName="Godina" #focusElement [MaxLength]="4"
            [ngClass]="{'is-invalid': submitted && fc.Godina.invalid}" [Label]="'PRAVONAGO.GODINA.SINGULAR'">
          </yt-input>
          <div class="form-error" *ngIf="submitted && fc.Godina.invalid">
            <span *ngFor="let validation of errorMessages.Godina">
              <span class="error-message" *ngIf="fc.Godina.hasError(validation.type)"><span
                  translate="{{validation.message}}"></span></span>
            </span>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <yt-osnov-za-pravo-na-go-update-container #baseInlineContainer
        [DetailModelData]="modelData.MainList.DetailList[0]" [ParentPropertyName]="'PravoNaGoID'"
        [ParentPropertyValue]="Item.ID" [Parameters]="TransferParameters">
      </yt-osnov-za-pravo-na-go-update-container>
    </div>
  </div>
</form>